/**
 * Fixed atmospheric background composed of blurred organic blobs.
 * Rendered once at the App level so it persists across navigation
 * without flickering and stays behind every interactive layer.
 *
 * Inspired by Balance, Headspace, Calm, Oura, Apple Health.
 */
export default function Atmosphere() {
  return (
    <div className="tk-atmosphere" aria-hidden="true" data-testid="atmosphere-background">
      <div className="blob blob-1 animate-drift-slow" />
      <div className="blob blob-2 animate-drift-slower" />
      <div className="blob blob-3 animate-drift-slow" />
      <div className="blob blob-4 animate-drift-slower" />
    </div>
  );
}
